import { render } from "./not-found.vue?vue&type=template&id=23d20e86&scoped=true&ts=true"
import script from "./not-found.vue?vue&type=script&lang=ts"
export * from "./not-found.vue?vue&type=script&lang=ts"

import "./not-found.vue?vue&type=style&index=0&id=23d20e86&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d20e86"]])

export default __exports__